<template>
    <div class="col-md-12">
        <div class="card card-search">
            <div class="card-body p-0">
                <div class="box-header">
                    <a data-toggle="collapse" href="#collapseFilter" aria-expanded="false"
                       aria-controls="collapseFilter" class="d-block">
                        <p class="box-title p-3 m-0 text-black-50"><strong>Summary -  System Types</strong> </p>
                    </a>
                </div>

                <div id="collapseFilter"
                     class="table-wrapper collapse pl-3 pr-3 pb-3 pt-0">
                    <div style="margin-top:10px">
                        <table class="table">
                            <tr>
                                <th width="25%">System Type</th>
                                <th>Quantity</th>
                            </tr>
                            <tr v-for="item in result">
                                <td><a :href="item.link">{{item.system_type}}</a></td>
                                <td>{{item.quantity}}</td>
                            </tr>
                        </table>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
import _ from "lodash";
import {URL_BASE} from "../../../utils/helper";

export default {
    name: "SiteHeaderSummaryComponent",
    props: {
        month: {
            default: (new Date()).getMonth() + 1
        },
        year: {
            default: (new Date()).getFullYear()
        }
    },
    data() {
        return {
            result: []
        }
    },
    watch: {
        month(val) {
            this.getTotal()
        },
        year(val) {
            this.getTotal()
        }
    },
    mounted() {
        this.getTotal()
    },
    methods: {
        getTotal() {
            this.$loading(true);
            let app = this;
            let params = {
                "month": this.month || '',
                "year": this.year,
            }

            var strParams = "";
            for (var key in params) {
                if (strParams != "") {
                    strParams += "&";
                }
                strParams += key + "=" + params[key];
            }

            axios.get(`${URL_BASE}/sites/inspection-summary/dashboard?${strParams}`)
                .then((response) => {
                    this.$loading(false);
                    app.result = response.data

                    app.result = app.result.map(function (el){

                        let link =  "/sites?filter=ID&month=" + params.month + "&year=" + params.year + "&system_types[]=" + el.id;
                        /*
                         el.ids.forEach((obj) => {
                             link += "&system_types[]=" + obj
                        });*/

                        el["link"] = link;

                        return el;
                    });
                })
                .catch(error => {
                    this.$loading(false);
                    let message = '';
                    if (_.has(error, 'response.data.friendly_message')) {

                        message = error.response.status + ' - ' + error.response.data.friendly_message;

                    } else if (_.has(error, 'response.status')) {

                        message = 'Request failed with status code ' + error.response.status;

                    } else {
                        message = 'Application failed with error: ' + error.message;
                        console.log(error);
                    }

                    showMessage('w', message);


                })
        }
    }
}
</script>

<style scoped>
    td{
        padding: 5px;
        font-size: 12px;
    }
</style>
